import { PsyAccountDetails } from "./common/queries"
import { ICalendar } from "./interfaces"

function isAnyCalendarBound(accountDetails: PsyAccountDetails) {
    return !!accountDetails.settings.calendar_id
}

function isCalendarAvailable(calendars: ICalendar[], accountDetails: PsyAccountDetails) {
    return calendars.some(({ id }) => id === accountDetails.settings.calendar_id)
}

export function isCalendarReady(accountDetails: PsyAccountDetails, calendars: ICalendar[]) {
    return isAnyCalendarBound(accountDetails) && isCalendarAvailable(calendars, accountDetails)
}

export function getInitialPath(accountDetails: PsyAccountDetails, calendars: ICalendar[]) {
    if (!isCalendarReady(accountDetails, calendars)) return "/settings"
    return "/calendar"
}

export function createPath(path = "") {
    return `/psychologist-account${path}`
}
